import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import Tooltip from "react-tooltip-lite";
import style from "./hint-bubble.module.css";

function HintBubble(props) {
    let className = clsx(style.hintBubbleWrapper, props.className);
    let content = <div className={style.hintBubbleTooltipWrapper}>{props.tooltipText}</div>;
    return (
        <Tooltip
            background="#333"
            className={className}
            content={content}
            direction="down"
            padding="0"
            tipContentHover={true}
        >
            <span className={style.hintBubble} />
        </Tooltip>
    );
}

export default HintBubble;

HintBubble.propTypes = {
    className: PropTypes.string,
    tooltipText: PropTypes.node.isRequired,
};
